import { Component, ChangeDetectionStrategy, output, inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { BreakpointObserver } from '@angular/cdk/layout'
import { toSignal } from '@angular/core/rxjs-interop'
import { map } from 'rxjs/operators'
import { NotificationsService } from '../../../core/services/notifications.service'
import { PetsFacade } from 'auth'
import { environment } from 'src/environments/environment'


@Component({
  selector: 'ex-app-header-actions',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule],
  templateUrl: './app-header-actions.component.html',
  styleUrls: ['./app-header-actions.component.scss']
})
export class AppHeaderActionsComponent {
  avatarClick = output<void>()

  readonly #notifs = inject(NotificationsService)
  readonly #bp = inject(BreakpointObserver)
  yummypetsUrl = environment.yummypets

  currentPet = inject(PetsFacade).currentPet

  countMessages = this.#notifs.countMessages
  countNotifications = this.#notifs.countNotifications

  isDesktop = toSignal(
    this.#bp.observe('(min-width: 960px)').pipe(map(r => r.matches)),
    { initialValue: false }
  )

  onAvatarClick() {
    if (!this.isDesktop()) this.avatarClick.emit()
  }
}
